import { render, staticRenderFns } from "./task-operate.vue?vue&type=template&id=aca2c22a"
import script from "./task-operate.vue?vue&type=script&lang=js"
export * from "./task-operate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports